// Simplified Bundle Maker - No Classes, Just Functions
document.addEventListener('DOMContentLoaded', function () {
    const bundleMaker = document.querySelector('[data-bundle-maker]');
    if (!bundleMaker) return;

    // State
    const bundleProducts = new Map();

    // Liquid renders values into the #bundle-maker-data JSON block. This is a static
    // asset, so Liquid tags here are NOT evaluated — always read config from that block.
    const bundleConfigEl = document.getElementById('bundle-maker-data');
    const BUNDLE_CONFIG = bundleConfigEl ? JSON.parse(bundleConfigEl.textContent) : {};
    const MAIN_PRODUCT = BUNDLE_CONFIG.main_product || {};
    const MAIN_PRODUCT_ID = String(MAIN_PRODUCT.id || '');
    const MAIN_PRODUCT_HANDLE = MAIN_PRODUCT.handle || '';
    const MAIN_PRODUCT_TITLE = MAIN_PRODUCT.title || '';
    const MAIN_PRODUCT_VENDOR = MAIN_PRODUCT.vendor || '';
    const MAIN_VARIANT_ID = String(MAIN_PRODUCT.selected_or_first_available_variant?.id || '');

    // Toggle to surface verbose logs while debugging the bundle flow.
    const BUNDLE_DEBUG = false;
    const debugLog = (...args) => {
        if (BUNDLE_DEBUG) debugLog(...args);
    };

    // Helper: Parse price
    function parsePrice(priceText) {
        const match = priceText.match(/[\d,]+\.?\d*/);
        return match ? parseFloat(match[0].replace(',', '')) : 0;
    }

    function normalizeVariantId(id) {
        const value = String(id || '');
        const gidMatch = value.match(/ProductVariant\/(\d+)/);
        return gidMatch ? gidMatch[1] : value;
    }

    // Single source of truth for WYATT product lookup.
    // Tries handle (products then product map), then falls back to matching by id.
    function findWyattProduct({ handle, id } = {}) {
        const shopify = window.WYATT?.shopify;
        if (!shopify) return null;
        if (handle) {
            if (shopify.products?.[handle]) return shopify.products[handle];
            if (shopify.product?.[handle]) return shopify.product[handle];
        }
        if (id != null && shopify.products) {
            const idStr = id.toString();
            for (const product of Object.values(shopify.products)) {
                if (product?.id != null && product.id.toString() === idStr) return product;
            }
        }
        return null;
    }

    function getWyattProduct(productId) {
        return findWyattProduct({ id: productId });
    }

    function getDomVariantsFromElement(productElement) {
        const variants = [];
        productElement.querySelectorAll('[data-variant-card]').forEach((card) => {
            variants.push({
                id: card.dataset.variantCard,
                price: parseInt(card.dataset.variantPrice, 10),
                available: card.dataset.variantAvailable === 'true',
                option1: card.dataset.variantOption1 || card.querySelector('.bundle-product__variant-text')?.textContent?.trim() || '',
                image: card.dataset.variantImage || '',
                sku: card.dataset.variantSku || '',
            });
        });
        return variants;
    }

    function getAllowedVariantIds(productId) {
        const ids = new Set();
        const productElement = bundleMaker.querySelector(`[data-bundle-product="${productId}"]`);
        if (productElement) {
            getDomVariantsFromElement(productElement).forEach((v) => ids.add(normalizeVariantId(v.id)));
            const defaultVariantId = productElement.dataset.defaultVariantId;
            if (defaultVariantId) ids.add(normalizeVariantId(defaultVariantId));
        }
        if (productId === MAIN_PRODUCT_ID) {
            ids.add(normalizeVariantId(MAIN_VARIANT_ID));
        }
        return ids;
    }

    function isVariantIdAllowed(productId, variantId) {
        const allowed = getAllowedVariantIds(productId);
        if (allowed.size === 0) return true;
        return allowed.has(normalizeVariantId(variantId));
    }

    // Pick the best variant: matching option1 + available, else first available, else first.
    function pickPreferredVariant(variants, targetOption1) {
        if (!Array.isArray(variants) || variants.length === 0) return null;
        const target = targetOption1 ? targetOption1.trim().toLowerCase() : '';
        return (
            (target && variants.find((v) => v.available && v.option1?.trim().toLowerCase() === target)) ||
            variants.find((v) => v.available) ||
            variants[0]
        );
    }

    // Prefer Liquid-rendered DOM variants over WYATT (WYATT can contain deleted variant IDs).
    function getProductData(productId) {
        const productElement = bundleMaker.querySelector(`[data-bundle-product="${productId}"]`);
        const wyattProduct = getWyattProduct(productId);
        if (!productElement) return wyattProduct || null;

        const title = productElement.querySelector('.bundle-product__title')?.textContent?.trim() || wyattProduct?.title || 'Product';
        const priceElement = productElement.querySelector('.prices--bundle .price');
        const price = priceElement ? parsePrice(priceElement.textContent) : 0;
        const variants = getDomVariantsFromElement(productElement);
        let defaultVariant = variants.find((v) => v.available) || variants[0] || null;

        // No DOM variant cards (single-variant product): synthesize from data-default-variant-id.
        const defaultVariantId = productElement.dataset.defaultVariantId;
        if (!defaultVariant && defaultVariantId) {
            const wyattMatch = wyattProduct?.variants?.find(
                (v) => normalizeVariantId(v.id) === normalizeVariantId(defaultVariantId)
            );
            defaultVariant = {
                id: defaultVariantId,
                price: wyattMatch?.price || price * 100,
                available: wyattMatch?.available !== false,
                option1: wyattMatch?.option1 || '',
                sku: wyattMatch?.sku || '',
            };
            variants.push(defaultVariant);
        }

        if (!defaultVariant) return null;

        return {
            id: productId,
            title,
            vendor: productElement.getAttribute('data-product-vendor') || wyattProduct?.vendor || '',
            variants,
            selected_or_first_available_variant: defaultVariant,
        };
    }

    // Hide empty rating divs
    function hideEmptyRatings() {
        const ratingDivs = bundleMaker.querySelectorAll('.bundle-product__rating');
        ratingDivs.forEach(ratingDiv => {
            const badgeDiv = ratingDiv.querySelector('.jdgm-widget');
            if (!badgeDiv) {
                // No badge div at all, remove the rating div
                ratingDiv.remove();
                return;
            }

            // Check if the badge div is hidden (display: none)
            const badgeStyle = window.getComputedStyle(badgeDiv);
            if (badgeStyle.display === 'none') {
                ratingDiv.remove();
                return;
            }

            // Check for Judge.me specific indicators of no reviews
            const averageRating = badgeDiv.getAttribute('data-average-rating');
            const numberOfReviews = badgeDiv.getAttribute('data-number-of-reviews');
            const prevBadge = badgeDiv.querySelector('.jdgm-prev-badge');

            if (averageRating === '0.00' || numberOfReviews === '0' ||
                (prevBadge && prevBadge.textContent.includes('No reviews'))) {
                ratingDiv.remove();
                return;
            }

            // Check if the badge div has no visible content
            if (badgeDiv.innerHTML.trim() === '' || badgeDiv.textContent.trim() === '') {
                ratingDiv.remove();
                return;
            }
        });
    }



    // Initialize products
    function initializeProducts() {
        // Add current product to bundle by default (config parsed once at top of file)
        const mainVariant = MAIN_PRODUCT.selected_or_first_available_variant || {};
        const currentVariant = {
            id: mainVariant.id,
            price: mainVariant.price,
            available: mainVariant.available,
            option1: mainVariant.option1,
            sku: mainVariant.sku,
        };
        const currentProductData = {
            id: MAIN_PRODUCT_ID,
            title: MAIN_PRODUCT_TITLE,
            vendor: MAIN_PRODUCT_VENDOR,
            variants: [currentVariant],
            selected_or_first_available_variant: currentVariant,
        };

        // Use a string key so all bundleProducts.get(MAIN_PRODUCT_ID) lookups match.
        bundleProducts.set(MAIN_PRODUCT_ID, {
            element: null,
            product: currentProductData,
            quantity: 1,
            added: true,
            variant: currentProductData.selected_or_first_available_variant,
        });

        // Add bundle products
        const products = bundleMaker.querySelectorAll('[data-bundle-product]');
        debugLog('Found bundle products:', products.length);

        products.forEach((productElement) => {
            const productId = productElement.dataset.bundleProduct;
            debugLog('Processing bundle product:', productId);

            const productData = getProductData(productId);
            debugLog('Product data for', productId, ':', productData);

            if (productData) {
                bundleProducts.set(productId, {
                    element: productElement,
                    product: productData,
                    quantity: 0,
                    added: false,
                    variant: productData.selected_or_first_available_variant,
                });
                debugLog('Added bundle product to map:', productId);
            } else {
                debugLog('No product data found for:', productId);
            }
        });

        // Update initial statuses
        bundleProducts.forEach((_, productId) => updateProductStatus(productId));
        updateBundleTotal();

        // Log price and SKU for all products in bundleProducts
        debugLog('=== BUNDLE PRODUCTS - PRICE & SKU ===');
        bundleProducts.forEach((bundleProduct, productId) => {
            const price = bundleProduct.variant?.price ? (bundleProduct.variant.price / 100).toFixed(2) : 'N/A';
            const sku = bundleProduct.variant?.sku || bundleProduct.product?.selected_or_first_available_variant?.sku || 'N/A';
            const title = bundleProduct.product?.title || 'Unknown';
            debugLog(`Product: ${title} (ID: ${productId})`, {
                Price: `$${price}`,
                SKU: sku,
                VariantID: bundleProduct.variant?.id || 'N/A',
                Added: bundleProduct.added,
                Quantity: bundleProduct.quantity
            });
        });
        debugLog('=== END BUNDLE PRODUCTS LOG ===');

        // Hide any empty rating divs (with delay to ensure Judge.me widgets are loaded)
        setTimeout(() => {
            hideEmptyRatings();
        }, 1000);

        // Watch for Judge.me widgets being added and hide empty ones
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1 && node.classList && node.classList.contains('jdgm-widget')) {
                            // A Judge.me widget was added, check if it should be hidden
                            setTimeout(() => {
                                hideEmptyRatings();
                            }, 100);
                        }
                    });
                }
            });
        });

        // Start observing
        observer.observe(bundleMaker, {
            childList: true,
            subtree: true
        });
    }

    // Update product status
    function updateProductStatus(productId) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct || !bundleProduct.element) return;

        const addedStatus = bundleProduct.element.querySelector('[data-bundle-status="added"]');
        const notAddedStatus = bundleProduct.element.querySelector('[data-bundle-status="not-added"]');

        // Hide both statuses first
        if (addedStatus) addedStatus.style.display = 'none';
        if (notAddedStatus) notAddedStatus.style.display = 'none';

        if (bundleProduct.added) {
            // Show added status (checkmark and quantity controls), hide Add button
            if (addedStatus) addedStatus.style.display = 'flex';
        } else {
            // Show Add button when not added
            if (notAddedStatus) notAddedStatus.style.display = 'block';
            // When product is removed from bundle, hide variant selection
            hideVariantSelection(productId);
        }
    }

    // Update product quantity
    function updateProductQuantity(productId) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct || !bundleProduct.element) return;

        const quantityValue = bundleProduct.element.querySelector('[data-quantity-value]');
        if (quantityValue) {
            quantityValue.textContent = bundleProduct.quantity;
        }
    }

    // Update bundle total
    function updateBundleTotal() {
        let total = 0;
        let totalItems = 0;

        debugLog('=== UPDATING BUNDLE TOTAL ===');
        debugLog('Bundle products:', bundleProducts);

        bundleProducts.forEach((bundleProduct, productId) => {
            debugLog(`Product ${productId}:`, {
                added: bundleProduct.added,
                variant: bundleProduct.variant,
                quantity: bundleProduct.quantity
            });

            if (bundleProduct.added && bundleProduct.variant) {
                const productTotal = bundleProduct.variant.price * bundleProduct.quantity;
                total += productTotal;
                totalItems += bundleProduct.quantity;
                debugLog(`Added to total: $${productTotal / 100} (${bundleProduct.quantity} qty)`);
            }
        });

        debugLog(`Final total: $${total / 100}, Items: ${totalItems}`);

        const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(total / 100);

        // Update ALL bundle total price elements
        const totalPriceElements = bundleMaker.querySelectorAll('[data-total-price]');
        debugLog('Found total price elements:', totalPriceElements.length);
        totalPriceElements.forEach((element) => {
            element.textContent = formattedPrice;
        });

        // Update bundle summary
        updateBundleSummary(total, totalItems);
    }

    // Update bundle summary section
    function updateBundleSummary(total, totalItems) {
        const bundleSummary = bundleMaker.querySelector('[data-bundle-summary]');
        const addedProductsContainer = bundleMaker.querySelector('[data-added-products]');
        const totalItemsElement = bundleMaker.querySelector('[data-total-items]');
        const summaryTotalPriceElement = bundleSummary?.querySelector('[data-total-price]');

        if (!bundleSummary || !addedProductsContainer) return;

        // Clear existing added products
        addedProductsContainer.innerHTML = '';

        // Add bundle products that are added (excluding current product since it's shown separately)
        let addedCount = 0;
        bundleProducts.forEach((bundleProduct, productId) => {
            if (bundleProduct.added && bundleProduct.product && productId !== MAIN_PRODUCT_ID) {
                // Add plus icon before each product (except the first one)
                if (addedCount > 0) {
                    const plusElement = document.createElement('div');
                    plusElement.className = 'bundle-summary__plus';
                    plusElement.textContent = '+';
                    addedProductsContainer.appendChild(plusElement);
                }

                const summaryProductElement = document.createElement('div');
                summaryProductElement.className = 'bundle-summary__added-product';
                summaryProductElement.dataset.productId = productId;

                // Get image: variant image for products with variants, featured/first product image for products without variants
                let imageSrc = '';
                let imageAlt = bundleProduct.product.title || 'Product';

                // Check if product has 1 or less variant
                const hasOneOrLessVariant = !bundleProduct.product.variants || bundleProduct.product.variants.length <= 1;

                // If product has 1 or less variant, use featured/first product image
                if (hasOneOrLessVariant) {
                    debugLog('=== FETCHING IMAGE FOR PRODUCT WITH 1 OR LESS VARIANT ===');
                    debugLog('Product ID:', productId);
                    debugLog('Variant count:', bundleProduct.product.variants ? bundleProduct.product.variants.length : 0);
                    debugLog('Product data:', bundleProduct.product);

                    // First, try to get from DOM (most reliable - already rendered)
                    const actualProductElement = bundleMaker.querySelector(`[data-bundle-product="${productId}"]`);
                    const productImage = actualProductElement?.querySelector('.bundle-product__image img');

                    if (productImage) {
                        // Get from data-full-image attribute (high quality) or src
                        let domImageSrc = productImage.getAttribute('data-full-image') || productImage.src;

                        // Check if it's a Liquid error (invalid URL from template)
                        if (domImageSrc && !domImageSrc.includes('Liquid error') && !domImageSrc.includes('invalid url')) {
                            imageSrc = domImageSrc;
                            imageAlt = productImage.alt || imageAlt;
                            debugLog('Image from DOM:', imageSrc);
                        } else {
                            debugLog('DOM image contains Liquid error, skipping:', domImageSrc);
                        }
                    }

                    // If DOM image not available or contains error, try product data and WYATT
                    if (!imageSrc || imageSrc.trim() === '' || imageSrc.includes('Liquid error') || imageSrc.includes('invalid url')) {
                        debugLog('DOM image not found or contains error, trying product data and WYATT...');

                        // Try WYATT product data first (most reliable for image URLs)
                        if (window.WYATT && window.WYATT.shopify && window.WYATT.shopify.products) {
                            debugLog('Trying WYATT data first...');
                            for (const [handle, wyattProduct] of Object.entries(window.WYATT.shopify.products)) {
                                if (wyattProduct.id && wyattProduct.id.toString() === productId.toString()) {
                                    debugLog('Found WYATT product:', wyattProduct);
                                    if (wyattProduct.featured_image) {
                                        imageSrc = wyattProduct.featured_image;
                                        debugLog('Image from WYATT featured_image:', imageSrc);
                                    } else if (wyattProduct.images && wyattProduct.images.length > 0) {
                                        const firstImage = wyattProduct.images[0];
                                        imageSrc = typeof firstImage === 'string' ? firstImage : (firstImage.src || firstImage.url || firstImage);
                                        debugLog('Image from WYATT images[0]:', imageSrc);
                                    }
                                    break;
                                }
                            }
                        }

                        // If WYATT didn't work, try product data
                        if (!imageSrc || imageSrc.trim() === '' || imageSrc.includes('Liquid error') || imageSrc.includes('invalid url')) {
                            debugLog('WYATT data not found, trying product data...');

                            // Try featured_image
                            if (bundleProduct.product.featured_image) {
                                imageSrc = bundleProduct.product.featured_image;
                                debugLog('Image from product.featured_image:', imageSrc);
                            }
                            // Try images array
                            else if (bundleProduct.product.images && bundleProduct.product.images.length > 0) {
                                const firstImage = bundleProduct.product.images[0];
                                imageSrc = typeof firstImage === 'string' ? firstImage : (firstImage.src || firstImage.url || firstImage);
                                debugLog('Image from product.images[0]:', imageSrc);
                            }
                        }
                    }

                    debugLog('Final imageSrc for 1-or-less-variant product:', imageSrc);
                }
                // If product has 2+ variants, use variant image
                else if (bundleProduct.variant && bundleProduct.variant.image) {
                    imageSrc = bundleProduct.variant.image;
                }

                // Format image URL with proper width (no fallbacks - show errors if image not found)
                // Validate imageSrc is a valid non-empty string and not a Liquid error
                if (imageSrc && typeof imageSrc === 'string' && imageSrc.trim() !== '' && imageSrc !== 'undefined' && imageSrc !== 'null' && !imageSrc.includes('Liquid error') && !imageSrc.includes('invalid url')) {
                    let cleanUrl = imageSrc.split('?')[0].split('#')[0].trim();

                    // Check if cleanUrl contains Liquid error
                    if (cleanUrl.includes('Liquid error') || cleanUrl.includes('invalid url')) {
                        console.error('ERROR: Image URL contains Liquid error:', {
                            productId: productId,
                            productTitle: bundleProduct.product.title,
                            originalImageSrc: imageSrc,
                            cleanUrl: cleanUrl
                        });
                        imageSrc = ''; // Clear invalid imageSrc
                        cleanUrl = '';
                    }

                    // Validate that we have a valid URL after cleaning
                    if (!cleanUrl || cleanUrl === '' || cleanUrl === 'undefined' || cleanUrl === 'null') {
                        console.error('ERROR: Invalid image URL after cleaning:', {
                            productId: productId,
                            productTitle: bundleProduct.product.title,
                            originalImageSrc: imageSrc,
                            cleanUrl: cleanUrl
                        });
                        imageSrc = ''; // Clear invalid imageSrc
                    } else {
                        // Normalize URL - handle all cases to prevent duplicate domains
                        const currentDomain = window.location.hostname;
                        const currentOrigin = window.location.origin;

                        // First, check if URL already has duplicate domain pattern and fix it
                        if (cleanUrl.includes(currentDomain + '/' + currentDomain) || cleanUrl.includes(currentDomain + '//' + currentDomain)) {
                            // Remove duplicate domain
                            cleanUrl = cleanUrl.replace(new RegExp(currentDomain + '/+' + currentDomain, 'g'), currentDomain);
                        }

                        // If URL doesn't start with http/https, make it absolute
                        if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://')) {
                            // Check if URL already contains the current domain in the path (e.g., /www.bambibaby.com/...)
                            if (cleanUrl.includes('/' + currentDomain + '/') || cleanUrl.startsWith('/' + currentDomain)) {
                                // URL already contains domain in path, just add protocol and remove leading slash
                                cleanUrl = 'https://' + cleanUrl.replace(/^\/+/, '');
                            } else if (cleanUrl.match(/^\/[^\/]+\.[^\/]+/)) {
                                // URL has a domain in path but not current domain, add protocol
                                cleanUrl = 'https:' + cleanUrl;
                            } else if (cleanUrl.startsWith('/')) {
                                // Relative URL starting with /, prepend origin
                                cleanUrl = currentOrigin + cleanUrl;
                            } else if (cleanUrl.startsWith('//')) {
                                // Protocol-relative URL, add https
                                cleanUrl = 'https:' + cleanUrl;
                            } else {
                                console.error('ERROR: Invalid URL format (not absolute and not starting with /):', {
                                    productId: productId,
                                    productTitle: bundleProduct.product.title,
                                    cleanUrl: cleanUrl
                                });
                                imageSrc = ''; // Clear invalid imageSrc
                                cleanUrl = '';
                            }
                        } else {
                            // URL already starts with http/https, but check if it has duplicate domain
                            // Pattern: https://domain.com//domain.com/... or https://domain.com/domain.com/...
                            const duplicatePattern = new RegExp('(https?:\\/\\/)(' + currentDomain.replace(/\./g, '\\.') + ')\\/+\\2', 'g');
                            if (duplicatePattern.test(cleanUrl)) {
                                // Remove duplicate domain
                                cleanUrl = cleanUrl.replace(duplicatePattern, '$1$2');
                            }
                        }

                        // Only set image if we have a valid URL (double check)
                        if (imageSrc && cleanUrl && cleanUrl.trim() !== '' && cleanUrl.length > 5) {
                            const imageUrlWithSize = cleanUrl + '?width=80';

                            debugLog('=== BUNDLE SUMMARY IMAGE ===');
                            debugLog('Product ID:', productId);
                            debugLog('Product Title:', bundleProduct.product.title);
                            debugLog('Has One Or Less Variant:', hasOneOrLessVariant);
                            debugLog('Variant Count:', bundleProduct.product.variants ? bundleProduct.product.variants.length : 0);
                            debugLog('Original imageSrc:', imageSrc);
                            debugLog('Clean URL:', cleanUrl);
                            debugLog('Final Image URL (with width):', imageUrlWithSize);
                            debugLog('===========================');

                            summaryProductElement.innerHTML = `
                  <img 
                    src="${imageUrlWithSize}"
                    alt="${imageAlt}"
                    width="80"
                    height="80"
                    loading="lazy"
                  >
                  <button type="button" class="bundle-summary__remove-product" data-remove-from-summary="×">×</button>
                `;
                        } else {
                            console.error('ERROR: Could not create valid image URL (URL too short or invalid):', {
                                productId: productId,
                                productTitle: bundleProduct.product.title,
                                imageSrc: imageSrc,
                                cleanUrl: cleanUrl,
                                cleanUrlLength: cleanUrl ? cleanUrl.length : 0
                            });
                        }
                    }
                } else {
                    // No fallback - show error in console
                    console.error('ERROR: No image found for product with 1 or less variant:', {
                        productId: productId,
                        productTitle: bundleProduct.product.title,
                        hasOneOrLessVariant: hasOneOrLessVariant,
                        variantCount: bundleProduct.product.variants ? bundleProduct.product.variants.length : 0,
                        imageSrc: imageSrc,
                        imageSrcType: typeof imageSrc,
                        productData: bundleProduct.product,
                        variant: bundleProduct.variant
                    });
                }

                addedProductsContainer.appendChild(summaryProductElement);
                addedCount++;
            }
        });

        // Update total items using aggregated quantities passed from updateBundleTotal
        if (totalItemsElement) {
            totalItemsElement.textContent = `Total (${totalItems})`;
        }

        // Show/hide bundle summary based on whether there are added bundle products
        // Only show when at least one bundle product (not current product) is added
        let bundleProductsAdded = 0;
        bundleProducts.forEach((bundleProduct, productId) => {
            if (bundleProduct.added && productId !== MAIN_PRODUCT_ID) {
                bundleProductsAdded++;
            }
        });
        const footer = document.querySelector('footer.page-footer .page-footer__content.content-wrapper');
        function updateFooterMargin() {
            if (!bundleSummary || !footer) return;
            if (bundleSummary.offsetHeight > 0) {
                footer.style.paddingBottom = bundleSummary.offsetHeight + 'px';
            } else {
                footer.style.paddingBottom = '';
            }
        }
        if (bundleProductsAdded > 0) {
            bundleSummary.style.display = 'block';
            updateFooterMargin();
        } else {
            bundleSummary.style.display = 'none';
            if (footer) {
                footer.style.paddingBottom = '';
            }
        }
    }

    // Show variant selection
    function showVariantSelection(productId) {
        debugLog('=== SHOWING VARIANT SELECTION ===');
        debugLog('Product ID:', productId);

        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct || !bundleProduct.element) {
            debugLog('No bundle product or element found');
            return;
        }

        const variantContainer = bundleProduct.element.querySelector('[data-bundle-variant]');
        const moreDetails = bundleProduct.element.querySelector('.bundle-product__more-details');

        debugLog('Variant container found:', variantContainer);
        debugLog('More details found:', moreDetails);

        // Add 'open' class to variant container to show it
        if (variantContainer) {
            variantContainer.classList.add('open');
            debugLog('Added "open" class to variant container');
        }

        // Show more details when variant selection is open
        if (moreDetails) {
            moreDetails.classList.add('show');
            debugLog('Added "show" class to more details');
        }

        // Don't auto-select any variant - let user choose
    }

    // Hide variant selection
    function hideVariantSelection(productId) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct || !bundleProduct.element) return;

        const variantContainer = bundleProduct.element.querySelector('[data-bundle-variant]');
        const moreDetails = bundleProduct.element.querySelector('.bundle-product__more-details');

        // Remove open class from variant container
        if (variantContainer) {
            variantContainer.classList.remove('open');
        }

        // Hide more details when variant selection is closed
        if (moreDetails) {
            moreDetails.classList.remove('show');
        }

        // Clear variant selection
        const variantCards = bundleProduct.element.querySelectorAll('[data-variant-card]');
        variantCards.forEach(card => {
            card.classList.remove('bundle-product__variant-card--selected');
        });
    }

    // Add to bundle (for Add button only)
    function addToBundle(productId) {
        debugLog('=== ADDING TO BUNDLE ===');
        debugLog('Product ID:', productId);

        const bundleProduct = bundleProducts.get(productId);
        debugLog('Bundle product found:', bundleProduct);

        if (!bundleProduct) {
            debugLog('No bundle product found for ID:', productId);
            return;
        }

        // If not already added, add it with quantity 1
        if (!bundleProduct.added) {
            bundleProduct.added = true;
            bundleProduct.quantity = 1;
        } else {
            // If already added, don't change quantity - just return
            return;
        }

        // Auto-select a variant: match main product's option1, else first available, else first.
        const variants = bundleProduct.product.variants;
        if (variants && variants.length > 0) {
            const mainProduct = bundleProducts.get(MAIN_PRODUCT_ID);
            const selectedVariant = pickPreferredVariant(variants, mainProduct?.variant?.option1);

            if (selectedVariant) {
                bundleProduct.variant = selectedVariant;
                const variantNameElement = bundleProduct.element.querySelector('[data-current-variant-name]');
                if (variantNameElement) {
                    variantNameElement.textContent = selectedVariant.option1;
                }
            }
        }

        updateProductStatus(productId);
        updateBundleTotal();

        // Show variant selection and reflect the chosen variant card visually.
        if (variants && variants.length > 0) {
            showVariantSelection(productId);

            // Wait for the open transition (0.3s) before marking the card selected.
            setTimeout(() => {
                const selectedVariant = bundleProduct.variant;
                if (!selectedVariant) return;
                const variantCard = bundleProduct.element.querySelector(`[data-variant-card="${selectedVariant.id}"]`);
                if (variantCard) {
                    variantCard.classList.add('bundle-product__variant-card--selected');
                }
            }, 350);
        }
    }

    // Add to bundle when variant is selected (real-time)
    // incrementIfAdded: if true, increment quantity when product is already added (for modal adds)
    function addToBundleWithVariant(productId, variantId, incrementIfAdded = false) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct) return;

        const selectedVariant = bundleProduct.product.variants.find(
            (v) => normalizeVariantId(v.id) === normalizeVariantId(variantId)
        );
        if (!selectedVariant) return;

        // Check if variant is actually changing
        const isVariantChanging =
            !bundleProduct.variant ||
            normalizeVariantId(bundleProduct.variant.id) !== normalizeVariantId(variantId);

        bundleProduct.variant = selectedVariant;

        // If not already added, add it now
        if (!bundleProduct.added) {
            bundleProduct.added = true;
            bundleProduct.quantity = 1;
            updateProductStatus(productId);
        } else {
            // If already added
            if (incrementIfAdded) {
                // From modal: increment quantity
                bundleProduct.quantity += 1;
                updateProductQuantity(productId);
            } else if (isVariantChanging) {
                // From variant card: just update the variant (don't increment quantity)
                updateProductQuantity(productId);
            }
            // If variant is not changing and product is already added, do nothing
        }

        updateBundleTotal();
    }

    // Update variant selector in bundle to show selected variant
    function updateVariantSelectorInBundle(productId, selectedVariant) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct || !bundleProduct.element) return;

        // Show variant selection if not already open
        const variantContainer = bundleProduct.element.querySelector('[data-bundle-variant]');
        if (variantContainer && !variantContainer.classList.contains('open')) {
            showVariantSelection(productId);
        }

        // Clear all selected states
        const variantCards = bundleProduct.element.querySelectorAll('[data-variant-card]');
        variantCards.forEach(card => {
            card.classList.remove('bundle-product__variant-card--selected');
        });

        // Select the specific variant card
        const targetCard = bundleProduct.element.querySelector(`[data-variant-card="${selectedVariant.id}"]`);
        if (targetCard) {
            targetCard.classList.add('bundle-product__variant-card--selected');
        }

        // Update variant name display
        const variantNameElement = bundleProduct.element.querySelector('[data-current-variant-name]');
        if (variantNameElement) {
            variantNameElement.textContent = selectedVariant.option1;
        }
    }

    // Sync main product variant selection to all bundle products
    function syncMainProductVariantToBundleProducts(mainProductVariant) {
        if (!mainProductVariant || !mainProductVariant.option1) {
            debugLog('No main product variant or option1 to sync');
            return;
        }

        const targetOption1 = mainProductVariant.option1;

        debugLog('Syncing main product variant option1 to bundle products:', targetOption1);

        bundleProducts.forEach((bundleProduct, productId) => {
            // Skip the main product itself
            if (productId === MAIN_PRODUCT_ID) return;

            // Only sync if product is added to bundle and has variants
            if (!bundleProduct.added || !bundleProduct.product || !bundleProduct.product.variants || bundleProduct.product.variants.length === 0) {
                return;
            }

            const matchingVariant = pickPreferredVariant(bundleProduct.product.variants, targetOption1);

            if (matchingVariant) {
                // Update the bundle product's variant
                bundleProduct.variant = matchingVariant;
                debugLog(`Synced variant for product ${productId}:`, matchingVariant);

                // Update visual selection if element exists
                if (bundleProduct.element) {
                    updateVariantSelectorInBundle(productId, matchingVariant);
                }

                // Update bundle total
                updateBundleTotal();
            }
        });
    }

    // Add all to cart
    async function addAllToCart() {
        const addAllButton = bundleMaker.querySelector('[data-bundle-add-all]');
        if (!addAllButton) return;

        const originalText = addAllButton.textContent;
        addAllButton.textContent = 'Adding to Cart...';
        addAllButton.disabled = true;

        try {
            // Get current product (main product)
            const currentProduct = bundleProducts.get(MAIN_PRODUCT_ID);
            if (!currentProduct || !currentProduct.variant) {
                throw new Error('Current product not found');
            }

            // Sync PDP variant id so cart line matches the selected main variant
            const pdpVariantInput =
                document.querySelector('product-options input[name="id"]') ||
                document.querySelector('product-form input[name="id"]');
            if (pdpVariantInput?.value) {
                const pdpVariantId = pdpVariantInput.value;
                const mainVariantMatch = currentProduct.product.variants?.find(
                    (v) => normalizeVariantId(v.id) === normalizeVariantId(pdpVariantId)
                );
                currentProduct.variant = mainVariantMatch || {
                    ...currentProduct.variant,
                    id: pdpVariantId,
                };
            }

            // Reconcile accessory variants with DOM (avoids stale WYATT/deleted variant IDs)
            bundleProducts.forEach((bundleProduct, productId) => {
                if (productId === MAIN_PRODUCT_ID || !bundleProduct.added || !bundleProduct.element) return;
                const domVariants = getDomVariantsFromElement(bundleProduct.element);
                if (!domVariants.length) return;
                const currentId = normalizeVariantId(bundleProduct.variant?.id);
                const stillValid = domVariants.some((v) => normalizeVariantId(v.id) === currentId);
                if (!stillValid) {
                    bundleProduct.variant = domVariants.find((v) => v.available) || domVariants[0];
                }
            });

            const invalidBundleItems = [];
            bundleProducts.forEach((bundleProduct, productId) => {
                if (productId === MAIN_PRODUCT_ID || !bundleProduct.added || !bundleProduct.variant) return;
                if (!isVariantIdAllowed(productId, bundleProduct.variant.id)) {
                    invalidBundleItems.push(bundleProduct.product?.title || 'Bundle item');
                }
            });
            if (invalidBundleItems.length > 0) {
                throw new Error(
                    `Please re-select a variant for: ${invalidBundleItems.join(', ')}. An item in this bundle is no longer available.`
                );
            }

            // Collect bundle components
            const bundleProductsList = [];
            const bundleComponentTitlesWithQty = [];
            let totalPrice = 0;
            let totalItems = 0;

            bundleProducts.forEach((bundleProduct, productId) => {
                if (bundleProduct.added && bundleProduct.variant) {
                    const baseTitle = bundleProduct.product.title;
                    // Title with quantity suffix only when quantity > 1
                    const titleWithQty = bundleProduct.quantity > 1 ? `${baseTitle} (${bundleProduct.quantity})` : baseTitle;
                    if (productId !== MAIN_PRODUCT_ID) bundleComponentTitlesWithQty.push(titleWithQty);
                    // Include qty in variants payload for reference

                    bundleProductsList.push({
                        variantId: bundleProduct.variant.id,
                        price: bundleProduct.variant.price,
                        quantity: bundleProduct.quantity
                    });
                    totalPrice += bundleProduct.variant.price * bundleProduct.quantity;
                    totalItems += bundleProduct.quantity;
                }
            });



            // Create full titles string for bundle products
            const fullTitles = bundleComponentTitlesWithQty.length > 0 ? bundleComponentTitlesWithQty.join(', ') : '';

            // Get bundle image (first added product's image)
            let bundleImage = '';

            if (bundleProductsList.length > 0) {
                // Get the first added bundle product's image
                const firstAddedProduct = Array.from(bundleProducts.entries()).find(([productId, product]) =>
                    product.added && productId !== MAIN_PRODUCT_ID
                );
                if (firstAddedProduct && firstAddedProduct[1].element) {
                    const imgElement = firstAddedProduct[1].element.querySelector('.bundle-product__image img');
                    bundleImage = imgElement ? imgElement.src : '';
                }
            }

            // Create bundle properties with all required fields
            // Total items = current product (1) + added bundle products
            const totalBundleItems = bundleProductsList.length;
            const bundleProperties = {
                _bundle: 'true',
                _bundle_type: 'custom_set',
                _bundle_title: 'Travel System Bundle',
                _bundle_subtitle: 'Custom set',
                _bundle_count: `${totalBundleItems} items: ${currentProduct.product.title}${fullTitles ? ', ' + fullTitles : ''}`,
                _bundle_products: fullTitles,
                _bundle_image: bundleImage,
                _bundle_variants: JSON.stringify(bundleProductsList),
                _bundle_total_price: totalPrice, // Store in cents for Shopify
                _bundle_sku: currentProduct.variant.sku || 'BUNDLE-001',
                _bundle_vendor: currentProduct.product.vendor || MAIN_PRODUCT_VENDOR
            };



            // Create FormData for cart submission
            const formData = new FormData();
            formData.append('id', currentProduct.variant.id);
            formData.append('quantity', '1');

            // Add bundle properties using FormData format
            formData.append('properties[_bundle]', bundleProperties._bundle);
            formData.append('properties[_bundle_type]', bundleProperties._bundle_type);
            formData.append('properties[_bundle_title]', bundleProperties._bundle_title);
            formData.append('properties[_bundle_subtitle]', bundleProperties._bundle_subtitle);
            formData.append('properties[_bundle_count]', bundleProperties._bundle_count);
            formData.append('properties[_bundle_products]', bundleProperties._bundle_products);
            formData.append('properties[_bundle_image]', bundleProperties._bundle_image);
            formData.append('properties[_bundle_variants]', bundleProperties._bundle_variants);
            formData.append('properties[_bundle_total_price]', bundleProperties._bundle_total_price);
            formData.append('properties[_bundle_sku]', bundleProperties._bundle_sku);
            formData.append('properties[_bundle_vendor]', bundleProperties._bundle_vendor);
            formData.append('properties[src]', 'bundle-maker');



            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                debugLog('Bundle added to cart successfully:', result);

                // Use the same cart update mechanism as cart-items.js
                try {
                    // Fetch cart sections to update the display
                    const sectionsToRender = ['cart-count', 'cart'];
                    const sectionsResponse = await fetch('/cart.js', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });

                    if (sectionsResponse.ok) {
                        const cartData = await sectionsResponse.json();
                        debugLog('Cart data fetched:', cartData);

                        // Update cart count elements
                        const cartCountElements = document.querySelectorAll('[data-cart-count]');
                        cartCountElements.forEach(element => {
                            element.textContent = cartData.item_count;
                        });

                        // Trigger cart update event
                        document.dispatchEvent(new Event('cart:updated'));

                        // Open the mini cart drawer
                        const drawerOpenButton = document.querySelector('[data-drawer-open="[data-mini-cart]"]');
                        if (drawerOpenButton) {
                            drawerOpenButton.click();
                        }

                        // Force a page refresh of cart sections after a short delay
                        setTimeout(async () => {
                            try {
                                const sectionsResponse = await fetch(`/cart?view=icart&sections=${sectionsToRender.join(',')}`);
                                if (!sectionsResponse.ok) return;

                                const sectionsData = await sectionsResponse.json();
                                if (!sectionsData.cart) return;

                                const doc = new DOMParser().parseFromString(sectionsData.cart, 'text/html');
                                // Swap each cart region with its freshly rendered version.
                                ['[data-cart-items]', '[data-cart-totals]', '[data-cart-checkout]', '[data-cart-recommendations]'].forEach((selector) => {
                                    const current = document.querySelector(selector);
                                    const updated = doc.querySelector(selector);
                                    if (current && updated) current.outerHTML = updated.outerHTML;
                                });
                            } catch (error) {
                                console.error('Error updating cart sections:', error);
                            }
                        }, 300);
                    }
                } catch (error) {
                    console.error('Error updating cart:', error);
                }

                showSuccessMessage('Bundle added to cart successfully!');
            } else {
                throw new Error('Failed to add items to cart');
            }
        } catch (error) {
            console.error('Error adding bundle to cart:', error);
            showErrorMessage('Failed to add items to cart. Please try again.');
        } finally {
            addAllButton.textContent = originalText;
            addAllButton.disabled = false;
        }
    }

    // Lightweight toast. type: 'success' (green, 3s) | 'error' (red, 5s).
    function showToast(message, type = 'success') {
        const isError = type === 'error';
        const notification = document.createElement('div');
        notification.textContent = message;
        Object.assign(notification.style, {
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: isError ? '#f44336' : '#4caf50',
            color: 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            zIndex: '1000',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        });

        document.body.appendChild(notification);
        setTimeout(() => notification.remove(), isError ? 5000 : 3000);
    }

    const showSuccessMessage = (message) => showToast(message, 'success');
    const showErrorMessage = (message) => showToast(message, 'error');

    // Add to registry
    async function addToRegistry() {
        const addRegistryButton = bundleMaker.querySelector('[data-bundle-add-registry]');
        if (!addRegistryButton) return;

        const originalText = addRegistryButton.textContent;
        addRegistryButton.textContent = 'Adding to Registry...';
        addRegistryButton.disabled = true;

        try {
            // For now, we'll show a success message
            // In a real implementation, this would integrate with the registry system
            showSuccessMessage('Bundle added to registry successfully!');

            // You can implement actual registry functionality here
            // For example, make an API call to add the bundle to the user's registry

        } catch (error) {
            console.error('Error adding bundle to registry:', error);
            showErrorMessage('Failed to add bundle to registry. Please try again.');
        } finally {
            addRegistryButton.textContent = originalText;
            addRegistryButton.disabled = false;
        }
    }

    // Document-level delegation: click .bundle-product__inner → toggle "open" on .bundle-product__variant
    // (So it keeps working even if the section is re-rendered after page load.)
    // Guard: only register once so one click doesn't fire two handlers (add open then remove open).
    if (!window.__bundleMakerInnerClickBound) {
        window.__bundleMakerInnerClickBound = true;
        document.addEventListener('click', function (event) {
            const productInner = event.target.closest('.bundle-product__inner');
            if (!productInner) return;
            if (event.target.closest('[data-bundle-add]') || event.target.closest('.bundle-product__actions') || event.target.closest('[data-open-modal]')) return;
            const card = productInner.closest('[data-bundle-product]');
            const variantEl = card ? card.querySelector('.bundle-product__variant') : null;
            if (!variantEl) return;
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            variantEl.classList.toggle('open');
            if (variantEl.classList.contains('open')) {
                debugLog('open added');
            } else {
                debugLog('open removed');
            }
            const moreDetailsEl = card.querySelector('.bundle-product__more-details');
            if (moreDetailsEl) moreDetailsEl.classList.toggle('show');
            if (!variantEl.classList.contains('open')) {
                card.querySelectorAll('[data-variant-card]').forEach(function (c) { c.classList.remove('bundle-product__variant-card--selected'); });
            }
        }, true);
    }


    // Event Listeners - Single event handler for all clicks (on bundle maker)
    bundleMaker.addEventListener('click', function (event) {
        // Add button - When clicked, add product to bundle directly
        const addButton = event.target.closest('[data-bundle-add]');
        if (addButton) {
            event.preventDefault();
            const productElement = addButton.closest('[data-bundle-product]');
            const productId = productElement.dataset.bundleProduct;
            const bundleProduct = bundleProducts.get(productId);

            if (!bundleProduct) return;

            // Always add product to bundle when Add is clicked
            addToBundle(productId);
            return;
        }

        // Quantity controls
        const quantityButton = event.target.closest('[data-quantity-action]');
        if (quantityButton) {
            event.preventDefault();
            const action = quantityButton.dataset.quantityAction;
            const productElement = quantityButton.closest('[data-bundle-product]');
            const productId = productElement.dataset.bundleProduct;
            const bundleProduct = bundleProducts.get(productId);

            if (!bundleProduct) return;

            if (action === 'increase') {
                bundleProduct.quantity += 1;
            } else if (action === 'decrease') {
                bundleProduct.quantity -= 1;

                if (bundleProduct.quantity <= 0) {
                    bundleProduct.quantity = 0;
                    bundleProduct.added = false;
                    updateProductStatus(productId); // This will call hideVariantSelection
                    updateBundleTotal();
                    return;
                }
            }

            updateProductQuantity(productId);
            updateBundleTotal();
            return;
        }

        // Variant card selection
        const variantCard = event.target.closest('[data-variant-card]');
        if (variantCard) {
            event.preventDefault();
            const productElement = variantCard.closest('[data-bundle-product]');
            const productId = productElement.dataset.bundleProduct;
            const bundleProduct = bundleProducts.get(productId);

            if (!bundleProduct) return;

            const variantId = variantCard.dataset.variantCard;
            const variantAvailable = variantCard.dataset.variantAvailable === 'true';

            if (!variantAvailable) return;

            const variantGrid = productElement.querySelector('.bundle-product__variant-grid');
            if (variantGrid) {
                variantGrid.querySelectorAll('[data-variant-card]').forEach((card) => {
                    card.classList.remove('bundle-product__variant-card--selected');
                });
            }
            variantCard.classList.add('bundle-product__variant-card--selected');

            const selectedVariant = bundleProduct.product.variants.find((v) => v.id.toString() === variantId);
            if (selectedVariant) {
                const variantNameElement = productElement.querySelector('[data-current-variant-name]');
                if (variantNameElement) {
                    variantNameElement.textContent = selectedVariant.option1;
                }

                // Add to bundle with selected variant (real-time)
                addToBundleWithVariant(productId, variantId);
            }
            return;
        }


        // Add all to cart
        const addAllButton = event.target.closest('[data-bundle-add-all]');
        if (addAllButton) {
            event.preventDefault();
            addAllToCart();
            return;
        }

        // Remove product from bundle summary
        const removeButton = event.target.closest('[data-remove-from-summary]');
        if (removeButton) {
            event.preventDefault();
            const summaryProductElement = removeButton.closest('.bundle-summary__added-product');
            const productId = summaryProductElement?.dataset.productId;

            if (productId) {
                const bundleProduct = bundleProducts.get(productId);
                if (bundleProduct) {
                    bundleProduct.added = false;
                    bundleProduct.quantity = 0;
                    updateProductStatus(productId);
                    updateBundleTotal();
                }
            }
            return;
        }

        // Add to registry
        const addRegistryButton = event.target.closest('[data-bundle-add-registry]');
        if (addRegistryButton) {
            event.preventDefault();
            addToRegistry();
            return;
        }

        const openModalButton = event.target.closest('[data-open-modal]');
        if (openModalButton) {
            event.preventDefault();
            event.stopPropagation();
            const productId = openModalButton.dataset.openModal;
            openModal(productId);
            return;
        }
    });

    // Modal functionality
    const modal = document.querySelector('[data-product-modal]');
    const modalOverlay = document.querySelector('[data-modal-overlay]');
    const modalClose = document.querySelector('[data-modal-close]');
    let currentModalProduct = null;
    let modalScrollY = 0;
    let modalScrollLocked = false;

    function keepPageAtSameScroll() {
        if (!modalScrollLocked) return;
        if (window.scrollY !== modalScrollY) {
            window.scrollTo({ top: modalScrollY, left: 0, behavior: 'instant' });
        }
    }

    function preventBackgroundWheelTouch(event) {
        if (!modalScrollLocked) return;
        const isInsideModal = event.target && event.target.closest && event.target.closest('[data-product-modal]');
        if (!isInsideModal) {
            event.preventDefault();
        }
    }

    function preventBackgroundScrollKeys(event) {
        if (!modalScrollLocked) return;
        const blockedKeys = [' ', 'PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown'];
        if (blockedKeys.includes(event.key)) {
            const isInsideModal = event.target && event.target.closest && event.target.closest('[data-product-modal]');
            if (!isInsideModal) {
                event.preventDefault();
            }
        }
    }

    function lockModalScroll() {
        const body = document.body;
        const html = document.documentElement;

        modalScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        modalScrollLocked = true;

        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        html.style.overscrollBehavior = 'none';

        window.addEventListener('scroll', keepPageAtSameScroll, { passive: true });
        document.addEventListener('wheel', preventBackgroundWheelTouch, { passive: false });
        document.addEventListener('touchmove', preventBackgroundWheelTouch, { passive: false });
        document.addEventListener('keydown', preventBackgroundScrollKeys, { passive: false });
    }

    function unlockModalScroll() {
        const body = document.body;
        const html = document.documentElement;
        const saved = modalScrollY;

        modalScrollLocked = false;
        window.removeEventListener('scroll', keepPageAtSameScroll);
        document.removeEventListener('wheel', preventBackgroundWheelTouch);
        document.removeEventListener('touchmove', preventBackgroundWheelTouch);
        document.removeEventListener('keydown', preventBackgroundScrollKeys);

        // Force unlock to avoid stale lock styles from any previous attempts.
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('left');
        body.style.removeProperty('right');
        body.style.removeProperty('width');
        html.style.removeProperty('overflow');
        html.style.removeProperty('overscroll-behavior');

        // Restore scroll reliably across browsers/themes.
        const restoreScroll = () => {
            window.scrollTo(0, saved);
            document.documentElement.scrollTop = saved;
            document.body.scrollTop = saved;
        };
        restoreScroll();
        requestAnimationFrame(restoreScroll);
        setTimeout(restoreScroll, 0);
    }

    function openModal(productId) {
        const bundleProduct = bundleProducts.get(productId);
        if (!bundleProduct) return;

        lockModalScroll();
        currentModalProduct = bundleProduct;
        populateModal(bundleProduct);

        modal.classList.add('open');
        modalOverlay.classList.add('open');
    }

    function closeModal() {
        modal.classList.remove('open');
        modalOverlay.classList.remove('open');
        currentModalProduct = null;
        unlockModalScroll();
    }

    // Populate modal with product data
    function populateModal(bundleProduct) {
        debugLog('=== MODAL POPULATE DEBUG ===');
        setModalImage(bundleProduct);
        setModalBrand(bundleProduct);
        setModalTitle(bundleProduct);
        setModalRating(bundleProduct);
        setModalSku(bundleProduct);
        setModalPrice(bundleProduct);
        setModalColorSwatches(bundleProduct);
        setModalAvailability(bundleProduct);
        setModalDescription(bundleProduct);
        setModalAddButton(bundleProduct);
    }

    // ---- populateModal helpers (split for readability; behavior unchanged) ----

    // Format a price given in cents as USD currency.
    function formatMoney(cents) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    // Read availability attributes from a variant's inline DOM card.
    function getVariantStockInfo(productElement, variantId) {
        const card = productElement?.querySelector(`[data-variant-card="${variantId}"]`);
        if (!card) return { availability: '', leadTime: '', inventoryQuantity: null };
        const inv = card.getAttribute('data-variant-inventory-quantity');
        return {
            availability: card.getAttribute('data-variant-availability') || '',
            leadTime: card.getAttribute('data-variant-lead-time') || '',
            inventoryQuantity: inv !== null ? parseInt(inv, 10) : null,
        };
    }

    // Availability text + out-of-stock flag (mirrors the Liquid template logic).
    function getStockState(variant, info) {
        const isSpecialOrder = info.availability === 'Special Order' && info.inventoryQuantity === 0 && !!info.leadTime;
        if (isSpecialOrder) return { isOutOfStock: false, text: info.leadTime };
        if (variant && variant.available) return { isOutOfStock: false, text: 'In stock | Ships in 24-48 hours' };
        return { isOutOfStock: true, text: 'Out of stock' };
    }

    function applyModalAddButtonState(isOutOfStock) {
        const btn = document.querySelector('[data-modal-add-button]');
        if (!btn) return;
        btn.disabled = isOutOfStock;
        btn.textContent = isOutOfStock ? 'Out of Stock' : 'Add to Travel System';
        btn.classList.toggle('out-of-stock', isOutOfStock);
    }

    function setModalImage(bundleProduct) {
        const modalImage = document.querySelector('[data-modal-image]');
        if (!modalImage) return;
        const productImage = bundleProduct.element?.querySelector('.bundle-product__image img');
        if (productImage) {
            const fullSrc = productImage.getAttribute('data-full-image') || productImage.src.replace(/width=\s*120/, 'width=1200');
            modalImage.innerHTML = `<img src="${fullSrc}" alt="${productImage.alt}" loading="lazy">`;
        } else {
            modalImage.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #6c757d;">No image available</div>';
        }
    }

    function setModalBrand(bundleProduct) {
        const product = bundleProduct.product;
        const modalBrand = document.querySelector('[data-modal-brand]');
        if (!modalBrand) return;
        let brand = product.vendor || bundleProduct.element?.getAttribute('data-product-vendor') || '';
        if (!brand) {
            const wyattProduct = findWyattProduct({ handle: product.handle, id: product.id });
            if (wyattProduct && wyattProduct.vendor) brand = wyattProduct.vendor;
        }
        modalBrand.textContent = brand || 'Nuna';
    }

    function setModalTitle(bundleProduct) {
        const modalTitle = document.querySelector('[data-modal-title]');
        if (modalTitle) modalTitle.textContent = bundleProduct.product.title || 'Product';
    }

    // Mirror the Judge.me rating badge from the bundle product card into the modal.
    function setModalRating(bundleProduct) {
        const modalRating = document.querySelector('[data-modal-rating]');
        if (!modalRating) return;
        const productRatingElement = bundleProduct.element?.querySelector('.bundle-product__rating');
        const judgeMeWidget = productRatingElement?.querySelector('.jdgm-widget');
        const prevBadge = judgeMeWidget?.querySelector('.jdgm-prev-badge');

        if (!judgeMeWidget || productRatingElement.innerHTML.trim() === '' || !prevBadge || prevBadge.innerHTML.trim() === '') {
            modalRating.style.display = 'none';
            return;
        }

        modalRating.style.display = 'flex';
        const modalStars = document.querySelector('[data-modal-rating] .product-modal__stars');
        const modalReviewCount = document.querySelector('[data-modal-review-count]');

        const starsContainer = prevBadge.querySelector('.jdgm-prev-badge__stars, .jdgm-stars');
        if (starsContainer) {
            modalStars.innerHTML = '';
            modalStars.appendChild(starsContainer.cloneNode(true));
        } else {
            const allStars = prevBadge.querySelectorAll('.jdgm-star');
            if (allStars.length > 0) {
                const starsFragment = document.createDocumentFragment();
                allStars.forEach(star => starsFragment.appendChild(star.cloneNode(true)));
                modalStars.innerHTML = '';
                modalStars.appendChild(starsFragment);
            }
        }

        const badgeTextEl = prevBadge.querySelector('.jdgm-prev-badge__text');
        const reviewMatch = badgeTextEl ? (badgeTextEl.textContent || '').match(/(\d+)\s*review/i) : null;
        if (reviewMatch) {
            const reviewCount = parseInt(reviewMatch[1]);
            modalReviewCount.textContent = `${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`;
        } else {
            const numberOfReviews = parseInt(prevBadge.getAttribute('data-number-of-reviews')) ||
                parseInt(judgeMeWidget.getAttribute('data-number-of-reviews')) || 0;
            modalReviewCount.textContent = numberOfReviews > 0
                ? `${numberOfReviews} ${numberOfReviews === 1 ? 'review' : 'reviews'}`
                : '';
        }
    }

    function setModalSku(bundleProduct) {
        const product = bundleProduct.product;
        const modalSku = document.querySelector('[data-modal-sku]');
        if (!modalSku) return;
        let sku = '';
        if (bundleProduct.variant && bundleProduct.variant.sku) {
            sku = bundleProduct.variant.sku;
        } else if (product.selected_or_first_available_variant && product.selected_or_first_available_variant.sku) {
            sku = product.selected_or_first_available_variant.sku;
        } else if (product.variants && product.variants.length > 0) {
            sku = product.variants[0].sku || '';
        } else if (bundleProduct.variant && bundleProduct.element) {
            const variantCard = bundleProduct.element.querySelector(`[data-variant-card="${bundleProduct.variant.id}"]`);
            if (variantCard) sku = variantCard.getAttribute('data-variant-sku') || '';
        }
        if (!sku) {
            const wyattProduct = findWyattProduct({ handle: product.handle, id: product.id });
            if (wyattProduct) {
                if (wyattProduct.variants && wyattProduct.variants.length > 0) sku = wyattProduct.variants[0].sku || '';
                else if (wyattProduct.selected_or_first_available_variant && wyattProduct.selected_or_first_available_variant.sku) sku = wyattProduct.selected_or_first_available_variant.sku;
            }
        }
        modalSku.textContent = sku ? `SKU: ${sku}` : '';
    }

    function setModalPrice(bundleProduct) {
        const product = bundleProduct.product;
        const modalPrice = document.querySelector('[data-modal-price]');
        if (!modalPrice) return;
        let priceValue = 0;
        if (bundleProduct.variant && bundleProduct.variant.price && bundleProduct.variant.price > 0) {
            priceValue = bundleProduct.variant.price;
        } else if (product.selected_or_first_available_variant && product.selected_or_first_available_variant.price && product.selected_or_first_available_variant.price > 0) {
            priceValue = product.selected_or_first_available_variant.price;
        } else if (product.variants && product.variants.length > 0) {
            priceValue = product.variants[0].price || 0;
        }
        if (priceValue === 0) {
            const wyattProduct = findWyattProduct({ handle: product.handle, id: product.id });
            if (wyattProduct) {
                if (wyattProduct.variants && wyattProduct.variants.length > 0) priceValue = wyattProduct.variants[0].price || 0;
                else if (wyattProduct.selected_or_first_available_variant && wyattProduct.selected_or_first_available_variant.price) priceValue = wyattProduct.selected_or_first_available_variant.price;
            }
        }
        if (priceValue === 0 && bundleProduct.element) {
            const priceElement = bundleProduct.element.querySelector('.prices--bundle .price');
            if (priceElement) priceValue = parsePrice(priceElement.textContent) * 100;
        }
        modalPrice.textContent = priceValue > 0 ? formatMoney(priceValue) : '';
    }

    function setModalColorSwatches(bundleProduct) {
        const product = bundleProduct.product;
        const modalColorSection = document.querySelector('[data-modal-color-section]');
        const modalCurrentColor = document.querySelector('[data-modal-current-color]');
        const modalColorSwatches = document.querySelector('[data-modal-color-swatches]');
        if (!modalColorSection || !modalColorSwatches) return;

        // Show color section only if product has 2 or more variants, otherwise hide it
        if (!(product.variants && product.variants.length > 1)) {
            modalColorSection.style.display = 'none';
            return;
        }

        modalColorSection.style.display = 'block';
        if (bundleProduct.variant && modalCurrentColor) {
            modalCurrentColor.textContent = bundleProduct.variant.option1 || 'Default';
        }

        modalColorSwatches.innerHTML = '';
        product.variants.forEach(variant => {
            if (!variant.option1) return;

            const swatch = document.createElement('div');
            swatch.className = 'product-modal__color-swatch';
            if (bundleProduct.variant && variant.id === bundleProduct.variant.id) {
                swatch.classList.add('selected');
            }

            // Pull swatch data (image/color) from inline variant cards if available
            const cardEl = bundleProduct.element?.querySelector(`[data-variant-card="${variant.id}"]`);
            const swatchImage = cardEl?.getAttribute('data-variant-swatch-image') || '';
            const swatchColor = cardEl?.getAttribute('data-variant-swatch-color') || '';

            let circle;
            if (swatchImage) {
                circle = `<div class="product-modal__color-circle"><img src="${swatchImage}" alt="${variant.option1}" class="swatch__image" width="24" height="24" loading="lazy"></div>`;
            } else {
                const bg = swatchColor || (variant.option1 || '').toLowerCase().replace(' ', '-');
                circle = `<div class="product-modal__color-circle"><span class="swatch__image" aria-label="${variant.option1}" style="background:${bg}"></span></div>`;
            }
            swatch.innerHTML = `${circle}<div class="product-modal__color-name">${variant.option1}</div>`;

            swatch.addEventListener('click', () => {
                modalColorSwatches.querySelectorAll('.product-modal__color-swatch').forEach(s => s.classList.remove('selected'));
                swatch.classList.add('selected');
                if (modalCurrentColor) modalCurrentColor.textContent = variant.option1;
                bundleProduct.variant = variant;

                const modalPrice = document.querySelector('[data-modal-price]');
                if (modalPrice) modalPrice.textContent = formatMoney(variant.price);

                // Update SKU
                const modalSku = document.querySelector('[data-modal-sku]');
                if (modalSku) {
                    const sku = variant.sku || cardEl?.getAttribute('data-variant-sku') || '';
                    modalSku.textContent = sku ? `SKU: ${sku}` : '';
                }

                // Update modal image with variant image
                const modalImage = document.querySelector('[data-modal-image]');
                if (modalImage) {
                    let variantImageUrl = cardEl?.getAttribute('data-variant-image') || '';
                    if (!variantImageUrl && variant.image) {
                        variantImageUrl = typeof variant.image === 'string'
                            ? variant.image
                            : (variant.image.src || variant.image.url || variant.featured_image || '');
                    }
                    if (variantImageUrl) {
                        let cleanUrl = variantImageUrl.split('?')[0].split('#')[0];
                        cleanUrl = cleanUrl.replace(/width=\d+/, 'width=1200');
                        if (!cleanUrl.includes('width=')) {
                            cleanUrl += (cleanUrl.includes('?') ? '&' : '?') + 'width=1200';
                        }
                        modalImage.innerHTML = `<img src="${cleanUrl}" alt="${variant.option1 || bundleProduct.product.title}" loading="lazy">`;
                    }
                }

                // Update availability text + add button from the same stock state
                const stock = getStockState(variant, getVariantStockInfo(bundleProduct.element, variant.id));
                const modalAvailabilityText = document.querySelector('[data-modal-availability-text]');
                if (modalAvailabilityText) modalAvailabilityText.textContent = stock.text;
                applyModalAddButtonState(stock.isOutOfStock);
            });

            modalColorSwatches.appendChild(swatch);
        });
    }

    function setModalAvailability(bundleProduct) {
        const modalAvailabilityText = document.querySelector('[data-modal-availability-text]');
        if (!modalAvailabilityText || !bundleProduct.variant) return;
        const stock = getStockState(bundleProduct.variant, getVariantStockInfo(bundleProduct.element, bundleProduct.variant.id));
        modalAvailabilityText.textContent = stock.text;
    }

    function setModalDescription(bundleProduct) {
        const product = bundleProduct.product;
        const modalDescription = document.querySelector('[data-modal-description]');
        if (!modalDescription) return;
        let description = '';

        // First, try to get from DOM element (most reliable for bundle products)
        if (bundleProduct.element) {
            const descScript = bundleProduct.element.querySelector('[data-product-description-json]');
            if (descScript) {
                try {
                    description = JSON.parse(descScript.textContent).description || '';
                } catch (e) {
                    console.error('Error parsing description JSON:', e);
                }
            }
            if (!description) {
                description = bundleProduct.element.getAttribute('data-product-description') || '';
            }
        }

        if (!description) {
            description = product.description || product.content || '';
        }
        if (!description) {
            const wyattProduct = findWyattProduct({ handle: product.handle, id: product.id });
            if (wyattProduct) description = wyattProduct.description || wyattProduct.content || '';
        }

        // Preserve HTML formatting if present
        if (description) modalDescription.innerHTML = description;
        else modalDescription.textContent = '';
    }

    function setModalAddButton(bundleProduct) {
        if (!bundleProduct.variant) return;
        const stock = getStockState(bundleProduct.variant, getVariantStockInfo(bundleProduct.element, bundleProduct.variant.id));
        applyModalAddButtonState(stock.isOutOfStock);
    }

    // Event listeners for modal
    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);

    // Handle modal add button
    const modalAddButton = document.querySelector('[data-modal-add-button]');
    modalAddButton.addEventListener('click', () => {
        if (currentModalProduct) {
            // Check if variant is available before adding
            if (!currentModalProduct.variant || !currentModalProduct.variant.available) {
                // Show error message or prevent add
                alert('This variant is out of stock and cannot be added to the bundle.');
                return;
            }

            // Add to bundle with the currently selected variant in modal
            // Pass true to increment quantity if product is already added
            addToBundleWithVariant(currentModalProduct.product.id, currentModalProduct.variant.id, true);

            // Update the variant selector in the main bundle to show the selected variant
            updateVariantSelectorInBundle(currentModalProduct.product.id, currentModalProduct.variant);

            closeModal();
        }
    });

    // Handle escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('open')) {
            closeModal();
        }
    });

    // Initialize
    initializeProducts();
    // Ensure the summary image reflects the current variant on initial load
    try {
        const currentProduct = bundleProducts.get(MAIN_PRODUCT_ID);
        if (currentProduct && currentProduct.variant) {
            updateBundleSummaryImage(currentProduct.variant);
        }
    } catch (e) { }

    // Update bundle summary image based on selected variant
    function updateBundleSummaryImage(variant) {
        const currentProductImage = bundleMaker.querySelector('[data-current-product-image]');
        if (!currentProductImage) return;

        // Get variant image URL
        let variantImageUrl = '';

        // Try different possible image properties from variant
        if (variant.featured_image) {
            variantImageUrl = variant.featured_image;
        } else if (variant.image) {
            variantImageUrl = typeof variant.image === 'string' ? variant.image : variant.image.src;
        } else if (variant.featured_media && variant.featured_media.preview) {
            variantImageUrl = variant.featured_media.preview.image.src;
        }

        // If we have a variant image, use it; otherwise try to get from product media
        if (!variantImageUrl) {
            // Try to get variant image from product media in WYATT data
            const productHandle = MAIN_PRODUCT_HANDLE;
            {
                const productData = findWyattProduct({ handle: productHandle });

                if (productData && productData.variants) {
                    const variantData = productData.variants.find(v => v.id.toString() === variant.id.toString());
                    if (variantData) {
                        if (variantData.featured_image) {
                            variantImageUrl = variantData.featured_image;
                        } else if (variantData.image) {
                            variantImageUrl = typeof variantData.image === 'string' ? variantData.image : variantData.image.src;
                        } else if (variantData.featured_media) {
                            variantImageUrl = variantData.featured_media.preview?.image?.src || '';
                        }
                    }
                }
            }
        }

        // Get from DOM (product media that updates with variant)
        // This is the most reliable source since product-options.js updates the media when variant changes
        const productMediaContainer = document.querySelector(`[data-product-media="${MAIN_PRODUCT_ID}"]`);
        if (productMediaContainer) {
            // Try to find an img element first
            const productMediaImg = productMediaContainer.querySelector('img');
            if (productMediaImg && productMediaImg.src) {
                // Clean the URL to get base image URL, then add width parameter
                const cleanUrl = productMediaImg.src.split('?')[0].split('#')[0];
                variantImageUrl = cleanUrl;
            } else {
                // Try to find a picture source
                const pictureSource = productMediaContainer.querySelector('source');
                if (pictureSource) {
                    if (pictureSource.srcset) {
                        // Extract first URL from srcset
                        const srcsetMatch = pictureSource.srcset.match(/https?:\/\/[^\s,]+/);
                        if (srcsetMatch) {
                            variantImageUrl = srcsetMatch[0].split('?')[0].split('#')[0];
                        }
                    } else if (pictureSource.src) {
                        variantImageUrl = pictureSource.src.split('?')[0].split('#')[0];
                    }
                }
            }
        }

        // Also try to get from variant's image if available in the variant object
        if (!variantImageUrl && variant.image) {
            if (typeof variant.image === 'string') {
                variantImageUrl = variant.image;
            } else if (variant.image.src) {
                variantImageUrl = variant.image.src;
            } else if (variant.image.url) {
                variantImageUrl = variant.image.url;
            }
        }

        // Update the image if we found a variant image
        if (variantImageUrl) {
            // Clean URL - remove existing query params and hash
            let cleanUrl = variantImageUrl.split('?')[0].split('#')[0];

            // If it's already a Shopify CDN URL, just add width parameter
            // Otherwise, ensure it's properly formatted
            if (!cleanUrl.includes('cdn.shopify.com') && !cleanUrl.startsWith('http')) {
                // If it's a relative path, make it absolute
                if (cleanUrl.startsWith('/')) {
                    cleanUrl = window.location.origin + cleanUrl;
                }
            }

            const imageUrlWithSize = cleanUrl + '?width=100';
            const imageUrlWithSize2x = cleanUrl + '?width=200';

            // If it's an img element, update src
            if (currentProductImage.tagName === 'IMG') {
                currentProductImage.src = imageUrlWithSize;
                // Update srcset for better quality
                currentProductImage.srcset = `${imageUrlWithSize} 1x, ${imageUrlWithSize2x} 2x`;
            } else {
                // If it's a placeholder div, replace with img
                const newImg = document.createElement('img');
                newImg.src = imageUrlWithSize;
                newImg.srcset = `${imageUrlWithSize} 1x, ${imageUrlWithSize2x} 2x`;
                newImg.alt = MAIN_PRODUCT_TITLE;
                newImg.width = 100;
                newImg.height = 100;
                newImg.loading = 'lazy';
                newImg.setAttribute('data-current-product-image', '');
                currentProductImage.replaceWith(newImg);
            }

            debugLog('Bundle summary image updated:', imageUrlWithSize);
        } else {
            debugLog('No variant image URL found for bundle summary');
        }
    }

    // Sync variant selection from product-details with bundle-maker
    function syncVariantFromProductDetails() {
        // Get the current product data from window.WYATT
        const currentProductId = MAIN_PRODUCT_ID;
        const productHandle = MAIN_PRODUCT_HANDLE;

        const productData = findWyattProduct({ handle: productHandle });

        if (!productData || !productData.variants) {
            debugLog('Product data not found for sync');
            return;
        }

        let lastVariantId = null;

        const checkVariantChange = () => {
            // Find the variant ID input (it might be replaced, so we query fresh each time)
            // Try product-options input first; fallback to product-form hidden input
            const variantIdInput = document.querySelector('product-options input[name="id"]') || document.querySelector('product-form input[name="id"]');
            if (!variantIdInput) return;

            const currentVariantId = variantIdInput.value;

            if (currentVariantId !== lastVariantId && currentVariantId) {
                lastVariantId = currentVariantId;

                // Find the variant from product data
                const selectedVariant = productData.variants.find(v =>
                    v.id.toString() === currentVariantId.toString()
                );

                if (selectedVariant) {
                    // Update the current product variant in bundleProducts
                    const currentProduct = bundleProducts.get(currentProductId);
                    if (currentProduct) {
                        currentProduct.variant = {
                            id: selectedVariant.id,
                            price: selectedVariant.price,
                            available: selectedVariant.available,
                            option1: selectedVariant.option1 || '',
                            image: selectedVariant.featured_image || selectedVariant.image || '',
                            sku: selectedVariant.sku || ''
                        };

                        debugLog('Variant synced to bundle maker:', selectedVariant);

                        // Sync this variant selection to all bundle products
                        syncMainProductVariantToBundleProducts(currentProduct.variant);

                        // Update bundle total immediately
                        updateBundleTotal();

                        // Update the bundle summary image to reflect the selected variant
                        // Use a slightly longer delay to ensure product media DOM has been updated by product-options.js
                        setTimeout(() => {
                            updateBundleSummaryImage(currentProduct.variant);
                        }, 600);
                    }
                }
            }
        };

        // Watch the product-options component for changes (including DOM replacement)
        const productOptions = document.querySelector(`product-options[data-product-options="${MAIN_PRODUCT_ID}"]`);
        if (productOptions) {
            // Watch for DOM changes in product-options that might indicate variant change
            const optionsObserver = new MutationObserver(() => {
                // Small delay to ensure the variant ID input has been updated after DOM replacement
                setTimeout(checkVariantChange, 150);
            });

            optionsObserver.observe(productOptions, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'data-selected']
            });

            // Use event delegation to catch option changes (works even when DOM is replaced)
            productOptions.addEventListener('change', (e) => {
                if (e.target.hasAttribute('data-product-option')) {
                    // Delay to allow product-options.js to update the variant ID input
                    setTimeout(checkVariantChange, 400);
                }
            });
        }

        // Initial check
        setTimeout(() => {
            const variantIdInput = document.querySelector('product-options input[name="id"]') || document.querySelector('product-form input[name="id"]');
            if (variantIdInput) {
                lastVariantId = variantIdInput.value || lastVariantId;
                checkVariantChange();
            }
        }, 500);

        // Add a resilient polling watcher in case DOM is replaced and events are missed
        // This ensures variant changes are always detected
        try {
            if (!window.__bundleVariantPoller) {
                window.__bundleVariantPoller = setInterval(() => {
                    try {
                        checkVariantChange();
                    } catch (e) { }
                }, 600);
            }
        } catch (e) { }
    }

    // Start syncing after a short delay to ensure DOM is ready
    setTimeout(() => {
        syncVariantFromProductDetails();
    }, 1000);
});